import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';

interface UseUpdateFact {
  field: string;
  value: string;
  factId: string;
}

const useUpdateFact = (caseId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ field, value, factId }: UseUpdateFact) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.PATCH, data: { [field]: value } });
      trackCustomEvent(TrackingEvents.UpdateFactContent, { field });
      return fetch(`${APIBaseChronos}/api/case/${caseId}/fact/${factId}`, fetchConfig);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryEntity.CaseFacts, { caseId }] });
        queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetFacts, { subsetId: caseId }] });
        queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetFactAllIds] });
        queryClient.invalidateQueries({ queryKey: [QueryEntity.KeyFacts, { caseId }] });
        toast.success('Fact successfully updated');
      },
      onError: () => {
        toast.error('Failed to update field');
      },
    },
  );
};

export default useUpdateFact;
